export { default } from "./useDialogStyle";
